import { axiosApiInstance } from './axios';
import ToastEmitter from '../components/toaster/ToastEmmited';

const apiRoot = '';

const giftSummaryApi = {
  getAllGiftSummaries: async (data) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/gift-summary/v1/get-all`, { params: data });
      return res;
    } catch (e: any) {
      ToastEmitter.notify(`Error executing thunk: ${e}`, 'error');
      throw e;
    }
  },
};

export default giftSummaryApi;
